// extracted by mini-css-extract-plugin
export default {"research_loader_container":"ResearcheLoader_research_loader_container__Oxnqm","loader":"ResearcheLoader_loader__q7eKr"};